import { HowTo } from '../types';

/** The support address. Shown as text: step copy renders no links. */
export const SUPPORT_EMAIL = 'support@rustleit.com';

/**
 * Getting help from Rustle It itself, for when no How To answers it.
 *
 * Staff only. An external member's questions belong with the setting that
 * invited them, not with us — and the steps point at Posts and Report History,
 * which they may not have.
 *
 * Also opened from the "Contact support" link at the foot of the help window,
 * so it must stay listed (non-empty `routes`) and keep its key.
 */
export const supportHowTos: HowTo[] = [
  {
    key: 'support.contact',
    version: 1,
    section: 'Support',
    title: 'Contact Rustle It support',
    summary:
      'Email us about a problem, and find the reference of the post or report it is about so we can look straight at it.',
    keywords: [
      'support', 'contact', 'email', 'help', 'helpdesk', 'problem', 'issue',
      'bug', 'broken', 'error', 'wrong', 'not working', 'doesn\'t work', 'fault',
      'report a problem', 'complain', 'complaint', 'question', 'ask', 'rustle',
      'ref', 'reference', 'id', 'number', 'code',
    ],
    routes: ['/'],
    audience: 'staff',
    steps: [
      {
        text: `Email **${SUPPORT_EMAIL}**. Say what you were doing, what you expected to happen, and what happened instead.`,
      },
      {
        text: 'Please **don\'t include children\'s names or details**, in the email or in any screenshot. We don\'t need them, and a reference (below) tells us which record you mean.',
      },
      {
        text: 'If it is about a post, open it. Its **Ref** (for example P-1234) is at the right of the **Created by** line — the button beside it copies it.',
        target: 'posts.support-ref',
        route: '/posts',
      },
      {
        text: 'If it is about a report, find it in **Report History**. Its **Ref** (for example R-56) is under the date in the **Generated** column.',
        target: 'history.support-ref',
        route: '/reports?tab=history',
      },
      {
        text: 'If we need to look into your organisation\'s records, we will ask an Admin to allow it first. Even then we see references, dates and counts — never children\'s names or what was written.',
      },
    ],
  },
];
